import React, { useEffect,useState } from "react";
import { useSelector } from "react-redux";
import {
  Avatar,
  Box,
  Card,
  CardContent,
  Divider,
  Stack,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import AddBoxOutlinedIcon from "@mui/icons-material/AddBoxOutlined";
// import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import DownloadOutlinedIcon from "@mui/icons-material/DownloadOutlined";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import NotificationsNoneOutlinedIcon from "@mui/icons-material/NotificationsNoneOutlined";
import ChevronRightRoundedIcon from "@mui/icons-material/ChevronRightRounded";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import WarningAmberOutlinedIcon from "@mui/icons-material/WarningAmberOutlined";
import AssignmentOutlinedIcon from "@mui/icons-material/AssignmentOutlined";
import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";
import BusinessOutlinedIcon from "@mui/icons-material/BusinessOutlined";
import VerifiedUserOutlinedIcon from "@mui/icons-material/VerifiedUserOutlined";
import MailOutlineOutlinedIcon from "@mui/icons-material/MailOutlineOutlined";
import PhoneOutlinedIcon from "@mui/icons-material/PhoneOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import LoginOutlinedIcon from "@mui/icons-material/LoginOutlined";
import PersonAddAlt1OutlinedIcon from "@mui/icons-material/PersonAddAlt1Outlined";
import TaskAltOutlinedIcon from "@mui/icons-material/TaskAltOutlined";
import NewReleasesOutlinedIcon from "@mui/icons-material/NewReleasesOutlined";
import SecurityOutlinedIcon from "@mui/icons-material/SecurityOutlined";
import BugReportOutlinedIcon from "@mui/icons-material/BugReportOutlined";
import BuildOutlinedIcon from "@mui/icons-material/BuildOutlined";
import LinkOutlinedIcon from "@mui/icons-material/LinkOutlined";
import InsertChartOutlinedIcon from "@mui/icons-material/InsertChartOutlined";
import NotificationsActiveOutlinedIcon from "@mui/icons-material/NotificationsActiveOutlined";
import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
import ArchiveOutlinedIcon from "@mui/icons-material/ArchiveOutlined";
import ReportProblemOutlinedIcon from "@mui/icons-material/ReportProblemOutlined";
import UserAvatar from "../../images/user.jpg";
import AppLoader from "../../components/AppLoader/AppLoader";
import "./DummyDashboard.scss";
import BannerImg from "../../images/background_stretched_300dpi.png";
import BannerImgAugust from "../../images/background_14august_landing.png";
import BannerImgDark from "../../images/background_stretched_dark.png";
import { isAugust14LandingBannerActive } from "../../utils/landingBanner";
import { officeName, permissionsVariables } from "../../services/Functions";
import { cfpBaseUrl } from "../../network/urls";

const quickActions = [
  {
    key: "view-applications",
    title: "Commercial Operations",
    description: "Open commercial operations modules",
    icon: DescriptionOutlinedIcon,
    theme: "blue",
  },
  {
    key: "technical-operations",
    title: "Technical Operations",
    description: "Open technical operations modules",
    icon: BuildOutlinedIcon,
    theme: "blue",
  },
  {
    key: "create-application",
    title: "Create New Application",
    description: "Initiate a new application",
    icon: AddBoxOutlinedIcon,
    theme: "green",
  },
  // {
  //   key: "search-application",
  //   title: "Search Application",
  //   description: "Search and track existing applications",
  //   icon: SearchOutlinedIcon,
  //   theme: "orange",
  // },
  {
    key: "download-reports",
    title: "Download Reports",
    description: "Download system reports",
    icon: DownloadOutlinedIcon,
    theme: "purple",
  },
];

// notices removed — dashboard now shows only API-provided eOps updates

const MetaBlock = ({ icon: Icon, label, value, august }) => (
  <Box
    className={`dummy-dashboard__meta-item${
      august ? " dummy-dashboard__meta-item--august" : ""
    }`}
  >
    <Box
      className={`dummy-dashboard__meta-icon${
        august ? " dummy-dashboard__meta-icon--august" : ""
      }`}
    >
      <Icon fontSize="small" />
    </Box>
    <Box>
      <Typography className="dummy-dashboard__meta-label">{label}</Typography>
      <Typography className="dummy-dashboard__meta-value">{value}</Typography>
    </Box>
  </Box>
);

const DummyDashboard = () => {
  const {
    name,
    roleName,
    cnic,
    cfcLevelName,
    email,
    phoneNo,
    lastLoginTime,
    profilePicture,
    code,
    token,
    roleTypeId,
  } = useSelector((state) => state.auth);
    const [subDivisions, setSubDivisions] = useState(
      JSON.parse(window.localStorage.getItem("subDivisions")) || [],
    );
     const [officeNameForDashboard, setOfficeNameForDashboard] = useState(
        officeName(code ? code : '', subDivisions),
      );
useEffect(()=>{
setOfficeNameForDashboard(officeName(code, subDivisions));
},[code, subDivisions])

function formatDateTime(dateString) {
  const date = new Date(dateString);

  const day = date.getDate();
  const year = date.getFullYear();
  const time = date.toLocaleTimeString('en-US'); // keeps AM/PM format

  const month = date.toLocaleString('en-US', { month: 'long' });

  return `${day} ${month} ${year} ${time}`;
}
  const dashboardMeta = [
    {
      label: "Role",
      value: roleName,
      icon: PersonOutlineOutlinedIcon,
    },
    {
      label: "Office",
      value: code === '10' ? "Power Information Technology Company (PITC)":officeNameForDashboard,
      icon: BusinessOutlinedIcon,
    },
    {
      label: "Last Login",
      value: lastLoginTime? formatDateTime(lastLoginTime) : '-',
      icon: AccessTimeOutlinedIcon,
    },
  ];

  const maskCnic = (cnicValue) => {
    if (!cnicValue && cnicValue !== 0) return "-";
    const str = String(cnicValue || "");
    const digits = str.replace(/\D/g, "");
    if (digits.length < 8) return str;
    const first = digits.slice(0, 4);
    const last = digits.slice(-4);
    return `${first}*****${last}`;
  };

  const [eopsNotices, setEopsNotices] = useState([]);
  const [eopsTotalCount, setEopsTotalCount] = useState(0);
  const [isEopsNoticesLoading, setIsEopsNoticesLoading] = useState(true);
  const navigate = useNavigate();

  // fetch eOps updates to show on dashboard
  useEffect(() => {
    let mounted = true;
    const fetchEops = async () => {
      if (mounted) {
        setIsEopsNoticesLoading(true);
      }
      try {
        const myHeaders = new Headers();
        if (token) myHeaders.append("Authorization", token);
        myHeaders.append("Content-Type", "application/json");
        const body = JSON.stringify({
          pageNumber: "1",
          pageSize: "10",
          officeCode: code ? String(code).slice(0, 2) : "10",
        });
        const requestOptions = {
          method: "POST",
          headers: myHeaders,
          body,
          redirect: "follow",
        };

        const res = await fetch(cfpBaseUrl + "eOpsUpdates/get", requestOptions);
        const text = await res.text();
        let json = null;
        try {
          json = JSON.parse(text);
        } catch (e) {
          json = res.ok ? await res.json() : null;
        }

        if (
          mounted &&
          json &&
          (json.status === "200" || json.status === 200) &&
          Array.isArray(json.data)
        ) {
          const mapped = json.data.map((it) => ({
            title: it.title || "",
            description: it.description || "",
            tone: it.isActive ? "info" : "warning",
            id: it.id,
            updateTypeId: it.updateTypeId ?? it.updateType?.updateTypeId,
            updateTypeName: it.updateTypeName ?? it.updateType?.updateTypeName,
          }));
          setEopsNotices(mapped);
          setEopsTotalCount(
            Number(
              json.totalRecords ??
                json.totalCount ??
                json.total ??
                mapped.length,
            ) || mapped.length,
          );
        } else if (mounted) {
          setEopsNotices([]);
          setEopsTotalCount(0);
        }
      } catch (e) {
        if (mounted) {
          setEopsNotices([]);
          setEopsTotalCount(0);
        }
      } finally {
        if (mounted) {
          setIsEopsNoticesLoading(false);
        }
      }
    };

    if (token) {
      fetchEops();
    } else if (mounted) {
      setEopsNotices([]);
      setEopsTotalCount(0);
      setIsEopsNoticesLoading(false);
    }

    return () => {
      mounted = false;
    };
  }, [token, code]);

  // pick an icon component based on the update type id/name
  const getUpdateIcon = (typeId, typeName) => {
    switch (Number(typeId)) {
      case 1:
        return InfoOutlinedIcon;
      case 2:
        return NewReleasesOutlinedIcon;
      case 3:
        return SecurityOutlinedIcon;
      case 4:
        return InfoOutlinedIcon;
      case 5:
        return BugReportOutlinedIcon;
      case 6:
        return BuildOutlinedIcon;
      case 7:
        return LinkOutlinedIcon;
      case 8:
        return InsertChartOutlinedIcon;
      case 9:
        return NotificationsActiveOutlinedIcon;
      case 10:
        return CalendarTodayOutlinedIcon;
      case 11:
        return ArchiveOutlinedIcon;
      case 12:
        return ReportProblemOutlinedIcon;
      default:
        // fallback: try matching by name
        if (typeof typeName === "string") {
          const name = typeName.toLowerCase();
          if (name.includes("security")) return SecurityOutlinedIcon;
          if (name.includes("release") || name.includes("release"))
            return NewReleasesOutlinedIcon;
          if (name.includes("api") || name.includes("integration"))
            return LinkOutlinedIcon;
          if (name.includes("data") || name.includes("report"))
            return InsertChartOutlinedIcon;
        }
        return AssignmentOutlinedIcon;
    }
  };

  // Map update type → CSS tone modifier (colors live in SCSS for light/dark)
  const getUpdateToneClass = (typeId, typeName) => {
    const id = Number(typeId);
    if (id >= 1 && id <= 12) return `type-${id}`;
    if (typeof typeName === "string") {
      const name = typeName.toLowerCase();
      if (name.includes("security")) return "type-3";
      if (name.includes("release")) return "type-2";
      if (name.includes("api") || name.includes("integration")) return "type-7";
      if (name.includes("data") || name.includes("report")) return "type-8";
    }
    return "type-4";
  };

  const userDetails = [
    { label: "CNIC", value: maskCnic(cnic), icon: AssignmentOutlinedIcon },
    { label: "Role", value: roleName, icon: VerifiedUserOutlinedIcon },
    { label: "Office", value: code === '10' ? "PITC":officeNameForDashboard, icon: BusinessOutlinedIcon },
    { label: "Email", value: email, icon: MailOutlineOutlinedIcon },
    { label: "Phone", value: phoneNo, icon: PhoneOutlinedIcon },
  ];

  const handleOpenProfileEditPopup = () => {
    window.dispatchEvent(new Event("open-profile-edit-popup"));
  };

  const showAugustBanner = isAugust14LandingBannerActive();
  const lightBanner = showAugustBanner ? BannerImgAugust : BannerImg;

  return (
    <Box className="dummy-dashboard">
      {isEopsNoticesLoading ? (
        <Box className="dummy-dashboard__page-loader" aria-busy="true">
          <AppLoader onLight label="Please wait..." />
        </Box>
      ) : null}
      <Box className="dummy-dashboard__surface">
        <Box
          className={`dummy-dashboard__hero${
            showAugustBanner ? " dummy-dashboard__hero--august" : ""
          }`}
        >
          <img
            src={lightBanner}
            alt=""
            className="dummy-dashboard__hero-bg dummy-dashboard__hero-bg--light"
          />
          <img
            src={BannerImgDark}
            alt=""
            className="dummy-dashboard__hero-bg dummy-dashboard__hero-bg--dark"
            aria-hidden
          />
          <Box className="dummy-dashboard__hero-copy">
            <Box className="dummy-dashboard__welcome-row">
              <Typography className="dummy-dashboard__welcome">
                Welcome back, {name}
              </Typography>
              {roleName ? (
                <span className="dummy-dashboard__role-pill">{roleName}</span>
              ) : null}
            </Box>
            {/* <Typography className="dummy-dashboard__subtitle">
              Your operations workspace — quick access to services, profile, and updates.
            </Typography> */}

            <Stack className="dummy-dashboard__meta" direction="row" spacing={0} useFlexGap flexWrap="wrap">
              {dashboardMeta.map((meta) => (
                <MetaBlock
                  key={meta.label}
                  {...meta}
                  august={showAugustBanner}
                />
              ))}
            </Stack>
          </Box>
        </Box>

        <Box className="dummy-dashboard__content">
          {roleTypeId === "1" && (
            <Box className="dummy-dashboard__quick-actions-section">
              <Box className="dummy-dashboard__section-head">
                <Typography className="dummy-dashboard__section-eyebrow">
                  Workspace
                </Typography>
                <Typography className="dummy-dashboard__section-title">
                  Quick Actions
                </Typography>
              </Box>

              <Box className="dummy-dashboard__quick-actions">
                {quickActions.map((action) => {
                  const ActionIcon = action.icon;

                  const handleClick = () => {
                    // View (0) and Create (1) should open Commercial Operations menu
                    if (
                      action.key === "view-applications" ||
                      action.key === "create-application"
                    ) {
                      window.dispatchEvent(new Event("openSidebar"));
                      const parentKey =
                        permissionsVariables.commercialOperations ||
                        "Commercial Operations";
                      window.dispatchEvent(
                        new CustomEvent("openSidebarMenu", {
                          detail: { keys: [parentKey] },
                        }),
                      );
                      return;
                    }

                    // Download Reports (3) opens the reports submenu depending on roleTypeId
                    if (action.key === "download-reports") {
                      window.dispatchEvent(new Event("openSidebar"));
                      if (String(roleTypeId) === "1") {
                        const parentKey =
                          permissionsVariables.commercialOperations ||
                          "Commercial Operations";
                        window.dispatchEvent(
                          new CustomEvent("openSidebarMenu", {
                            detail: { keys: [parentKey, "CommercialReports"] },
                          }),
                        );
                      } else if (String(roleTypeId) === "2") {
                        window.dispatchEvent(
                          new CustomEvent("openSidebarMenu", {
                            detail: {
                              keys: [
                                "TechnicalOperations",
                                "ComplaintsReports",
                              ],
                            },
                          }),
                        );
                      } else {
                        const parentKey =
                          permissionsVariables.commercialOperations ||
                          "Commercial Operations";
                        window.dispatchEvent(
                          new CustomEvent("openSidebarMenu", {
                            detail: { keys: [parentKey, "CommercialReports"] },
                          }),
                        );
                      }
                      return;
                    }

                    // Search card opens the global search popup
                    if (action.key === "search-application") {
                      window.dispatchEvent(new Event("openSearchPopup"));
                      return;
                    }

                    // Technical Operations card opens sidebar tree
                    if (action.key === "technical-operations") {
                      window.dispatchEvent(new Event("openSidebar"));
                      window.dispatchEvent(
                        new CustomEvent("openSidebarMenu", {
                          detail: { keys: ["TechnicalOperations"] },
                        }),
                      );
                      return;
                    }

                    if (action.onClick) action.onClick();
                  };

                  return (
                    <Box className="dummy-dashboard__quick-action-item" key={action.title}>
                      <Card
                        className={`dummy-dashboard__action-card dummy-dashboard__action-card--${action.theme}`}
                        onClick={handleClick}
                        sx={{ cursor: "pointer", minWidth: 0, maxWidth: "100%", width: "100%" }}
                      >
                        <CardContent className="dummy-dashboard__action-card-content">
                          <Box className="dummy-dashboard__action-icon">
                            <ActionIcon fontSize="small" />
                          </Box>
                          <Box className="dummy-dashboard__action-text">
                            <Typography className="dummy-dashboard__action-title">
                              {action.title}
                            </Typography>
                            <Typography className="dummy-dashboard__action-description">
                              {action.description}
                            </Typography>
                          </Box>
                          <Box className="dummy-dashboard__action-arrow">
                            <ChevronRightRoundedIcon />
                          </Box>
                        </CardContent>
                      </Card>
                    </Box>
                  );
                })}
              </Box>
            </Box>
          )}

          <Box className="dummy-dashboard__panels">
          <Box className="dummy-dashboard__panel-col dummy-dashboard__panel-col--user">
            <Card className="dummy-dashboard__panel-card dummy-dashboard__panel-card--user">
              <CardContent className="dummy-dashboard__panel-card-content">
                <Box
                  className={`dummy-dashboard__panel-header dummy-dashboard__panel-header--user${
                    showAugustBanner
                      ? " dummy-dashboard__panel-header--august"
                      : ""
                  }`}
                >
                  <Box className="dummy-dashboard__panel-header-left">
                    <PersonOutlineOutlinedIcon fontSize="small" />
                    <Typography>User Information</Typography>
                  </Box>
                  {/* <Typography
                    className="dummy-dashboard__panel-link"
                    onClick={handleOpenProfileEditPopup}
                    sx={{ cursor: "pointer" }}
                  >
                    <EditOutlinedIcon fontSize="small" />
                    Edit Profile
                  </Typography> */}
                </Box>

                <Divider className="dummy-dashboard__divider" />

                <Box className="dummy-dashboard__user-area">
                  <Avatar
                    src={profilePicture || UserAvatar}
                    alt={name}
                    className="dummy-dashboard__avatar"
                  />
                  <Box>
                    <Typography className="dummy-dashboard__user-name">
                      {name}
                    </Typography>
                  </Box>
                </Box>

                <Box className="dummy-dashboard__details">
                  {userDetails.map((detail) => {
                    const DetailIcon = detail.icon;

                    return (
                      <Box className="dummy-dashboard__detail-row" key={detail.label}>
                        <Box className="dummy-dashboard__detail-label-wrap">
                          <DetailIcon fontSize="small" />
                          <Typography className="dummy-dashboard__detail-label">
                            {detail.label}
                          </Typography>
                        </Box>
                        <Typography className="dummy-dashboard__detail-value">
                          {detail.value}
                        </Typography>
                      </Box>
                    );
                  })}
                </Box>
              </CardContent>
            </Card>
          </Box>

          <Box className="dummy-dashboard__panel-col dummy-dashboard__panel-col--announcements">
            <Card className="dummy-dashboard__panel-card dummy-dashboard__panel-card--announcements">
              <CardContent className="dummy-dashboard__panel-card-content">
                <Box
                  className={`dummy-dashboard__panel-header dummy-dashboard__panel-header--announcements${
                    showAugustBanner
                      ? " dummy-dashboard__panel-header--august"
                      : ""
                  }`}
                >
                  <Box className="dummy-dashboard__panel-header-left">
                      <NotificationsNoneOutlinedIcon fontSize="small" />
                      <Typography>Announcements / Notices</Typography>
                    </Box>
                    {eopsTotalCount > 4 && (
                      <Typography
                        className="dummy-dashboard__panel-link"
                        sx={{ cursor: "pointer" }}
                        onClick={() => navigate("/eops-updates")}
                      >
                        {`View All (${eopsTotalCount})`}
                      </Typography>
                    )}
                  </Box>

                <Divider className="dummy-dashboard__divider" />

                  <Stack
                    spacing={0.75}
                    className="dummy-dashboard__notice-list"
                  >
                    {eopsNotices && eopsNotices.length > 0 ? (
                      eopsNotices.slice(0, 4).map((notice) => {
                        const IconComp = getUpdateIcon(
                          notice.updateTypeId,
                          notice.updateTypeName,
                        );
                        return (
                          <Box
                            key={`eops-${notice.id}`}
                            className={`dummy-dashboard__notice-card dummy-dashboard__notice-card--${notice.tone} dummy-dashboard__notice-card--${getUpdateToneClass(
                              notice.updateTypeId,
                              notice.updateTypeName,
                            )}`}
                          >
                            <Box className="dummy-dashboard__notice-icon">
                              <IconComp fontSize="small" />
                            </Box>
                            <Box className="dummy-dashboard__notice-body">
                              <Typography className="dummy-dashboard__notice-title">
                                {notice.title}
                              </Typography>
                              <Typography className="dummy-dashboard__notice-description">
                                {notice.description}
                              </Typography>
                            </Box>
                          </Box>
                        );
                      })
                    ) : (
                      <Box className="dummy-dashboard__notice-empty">
                        No announcements available.
                      </Box>
                    )}
                  </Stack>
                </CardContent>
              </Card>
          </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default DummyDashboard;